import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAdminTranscriptFacets, IAdminTranscriptFilters, IAdminTranscriptListResponse, IAdminTranscriptRow, IAdminTranscriptStats } from "../models/interfaces";

export interface IAdminTranscriptExportState {
	filters: IAdminTranscriptFilters;
	rows: IAdminTranscriptRow[];
	stats: IAdminTranscriptStats | null;
	facets: IAdminTranscriptFacets | null;
	selectedRowKeys: string[];
	total: number;
	page: number;
	pageSize: number;
	loading: boolean;
	exporting: boolean;
}

export const initialState: IAdminTranscriptExportState = {
	filters: {},
	rows: [],
	stats: null,
	facets: null,
	selectedRowKeys: [],
	total: 0,
	page: 1,
	pageSize: 50,
	loading: false,
	exporting: false,
};

const adminTranscriptExportSlice = createSlice({
	name: "adminTranscriptExportSlice",
	initialState,
	reducers: {
		setTranscriptFilters: (state, action: PayloadAction<IAdminTranscriptFilters>) => {
			state.filters = action.payload;
			state.page = 1;
			state.selectedRowKeys = [];
		},
		setTranscriptPage: (state, action: PayloadAction<{ page: number; pageSize: number }>) => {
			state.page = action.payload.page;
			state.pageSize = action.payload.pageSize;
			state.selectedRowKeys = [];
		},
		setTranscriptList: (state, action: PayloadAction<IAdminTranscriptListResponse>) => {
			state.rows = action.payload.rows;
			state.stats = action.payload.stats;
			state.facets = action.payload.facets;
			state.total = action.payload.total;
			state.page = action.payload.page;
			state.pageSize = action.payload.page_size;
		},
		setTranscriptSelectedRows: (state, action: PayloadAction<string[]>) => {
			state.selectedRowKeys = action.payload;
		},
		setTranscriptLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setTranscriptExporting: (state, action: PayloadAction<boolean>) => {
			state.exporting = action.payload;
		},
		resetTranscriptExport: () => initialState,
	},
});

export const {
	resetTranscriptExport,
	setTranscriptExporting,
	setTranscriptFilters,
	setTranscriptList,
	setTranscriptLoading,
	setTranscriptPage,
	setTranscriptSelectedRows,
} = adminTranscriptExportSlice.actions;

export default adminTranscriptExportSlice.reducer;
